import React from 'react';
import { Filter, CheckCircle, Brain } from 'lucide-react';

type FilterOption = 'all' | 'completed' | 'not-completed';

interface ActivityFilterProps {
  selectedFilter: FilterOption;
  onFilterChange: (filter: FilterOption) => void;
  childName: string;
  regularCompleted: number;
  regularTotal: number;
  aiCompleted: number;
  aiTotal: number;
  isDarkMode?: boolean;
}

export function ActivityFilter({
  selectedFilter,
  onFilterChange,
  childName,
  regularCompleted,
  regularTotal,
  aiCompleted,
  aiTotal,
  isDarkMode = false
}: ActivityFilterProps) {
  return (
    <div className={`rounded-xl shadow-md border p-6 ${
      isDarkMode
        ? 'bg-gray-800 border-gray-700'
        : 'bg-white border-gray-200'
    }`}>
      {/* Header with Stats */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-2">
          <Filter className={`w-5 h-5 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`} />
          <h3 className={`text-lg font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
            Filter Activities for {childName}
          </h3>
        </div>

        <div className={`flex items-center space-x-4 text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
          <div className="flex items-center space-x-1">
            <CheckCircle className="w-4 h-4 text-green-500" />
            <span>Regular: {regularCompleted}/{regularTotal}</span>
          </div>
          <div className="flex items-center space-x-1">
            <Brain className="w-4 h-4 text-purple-500" />
            <span>AI: {aiCompleted}/{aiTotal}</span>
          </div>
        </div>
      </div>

      {/* Filter Buttons */}
      <div className="flex space-x-3">
        <button
          onClick={() => onFilterChange('all')}
          className={`px-4 py-2 rounded-lg font-medium transition-colors ${
            selectedFilter === 'all'
              ? 'bg-blue-100 text-blue-700 border-2 border-blue-300'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          All Activities
        </button>

        <button
          onClick={() => onFilterChange('completed')}
          className={`px-4 py-2 rounded-lg font-medium transition-colors ${
            selectedFilter === 'completed'
              ? 'bg-green-100 text-green-700 border-2 border-green-300'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          Completed Only
        </button>

        <button
          onClick={() => onFilterChange('not-completed')}
          className={`px-4 py-2 rounded-lg font-medium transition-colors ${
            selectedFilter === 'not-completed'
              ? 'bg-orange-100 text-orange-700 border-2 border-orange-300'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          Not Completed
        </button>
      </div>
    </div>
  );
}
